import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FloatingConsult from '@/components/feature/solution/FloatingConsult';
import LogisticsHero from '@/pages/smart-logistics/components/LogisticsHero';
import LogisticsOverview from '@/pages/smart-logistics/components/LogisticsOverview';
import LogisticsProducts from '@/pages/smart-logistics/components/LogisticsProducts';
import LogisticsScenarios from '@/pages/smart-logistics/components/LogisticsScenarios';
import LogisticsArchitecture from '@/pages/smart-logistics/components/LogisticsArchitecture';
import LogisticsCase from '@/pages/smart-logistics/components/LogisticsCase';
import { hero, overview, productMatrix, scenes, architecture, referenceCase } from '@/mocks/smart-logistics';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '智慧物流解决方案',
    serviceType: '智慧物流解决方案',
    description:
      '以智能视觉监控、商用显示与智慧物联为硬件底座，叠加 ePin 一物一码与九畴云市供应链平台，为仓储、运输、园区与末端配送构建端到端可感知、可调度、可追溯的数智化物流体系。',
    provider: {
      '@type': 'Organization',
      name: '华辉数智技术',
    },
    areaServed: '中国',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '产品与解决方案', item: 'https://www.huahui-digital.com/products' },
      { '@type': 'ListItem', position: 2, name: '解决方案', item: 'https://www.huahui-digital.com/solutions' },
      {
        '@type': 'ListItem',
        position: 3,
        name: '智慧物流',
        item: 'https://www.huahui-digital.com/solutions/smart-logistics',
      },
    ],
  },
];

export default function SmartLogistics() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="智慧物流解决方案｜仓储运输数智化与一物一码溯源｜华辉数智"
        description="华辉数智智慧物流解决方案：以智能视觉监控、商用显示与智慧物联为硬件底座，叠加 ePin 一物一码与九畴云市供应链平台，为仓储、运输、园区与末端配送构建端到端可感知、可调度、可追溯的数智化物流体系。"
        keywords="智慧物流,智慧仓储,智能分拣,物流数字化,一物一码溯源,冷链监控,物流园区"
        path="/solutions/smart-logistics"
        jsonLd={jsonLd}
      />

      <LogisticsHero data={hero} />
      <Breadcrumb
        items={[
          { label: '产品与解决方案', href: '/products' },
          { label: '解决方案', href: '/solutions' },
          { label: '智慧物流' },
        ]}
      />

      <main>
        <LogisticsOverview data={overview} />
        <LogisticsProducts data={productMatrix} />
        <LogisticsScenarios data={scenes} />
        <LogisticsArchitecture data={architecture} />
        <LogisticsCase data={referenceCase} />
      </main>

      <Footer />
      <FloatingConsult
        accentKey="green"
        href="/contact/business?utm_source=website&utm_medium=floating&utm_campaign=smart-logistics"
      />
    </div>
  );
}